import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/misTorneos.png'
import _imports_1 from '@/assets/icons/verLista.png'
import _imports_2 from '@/assets/icons/clasificacionTorneo.png'


const _withScopeId = n => (_pushScopeId("data-v-fa0523ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Icono personalizado",
  width: "30",
  height: "30"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "Icono personalizado",
  width: "40",
  height: "40"
}, null, -1))
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Icono personalizado",
  width: "30",
  height: "30"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "Icono personalizado",
  width: "40",
  height: "40"
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "Icono personalizado",
  width: "40",
  height: "40"
}, null, -1))

import { onMounted, ref } from "vue";
import { InscripcionUsuarioIndividualDTO } from "@/interfaces/Inscripcion";
import router from "@/router";
import {
  cancelarInscripcion,
  getInscripcionesIndividualByUser,
} from "@/services/InscripcionesService";
import ModalSuccess from "../Commons/ModalSuccess.vue";
import ModalError from "../Commons/ModalError.vue";
import { useAuth } from "@/composables/useAuth";
import ModalInscripcion from "./ModalInscripcion.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TablaInscripcionesTorneoIndividual',
  props: {
    isLoading: { type: Boolean },
    listaTorneos: {},
    idUsuario: {},
    disputado: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const isRegistering = ref<boolean>(false);

const currentInscripcionId = ref<number | null>(null);
const currentTorneoId = ref<number | null>(null);
const currentIdOrganizador = ref<number | null>(null);
const listaTorneos = ref<InscripcionUsuarioIndividualDTO[]>([]);

const showSuccessModal = ref<boolean>(false);
const showErrorModal = ref<boolean>(false);
const showModalInscripcion = ref<boolean>(false);
const showModalInscripcionEquipo = ref<boolean>(false);

const hasAcciones = ref<boolean>(false);
const { getidUsuario } = useAuth();
const idUsuarioLogger = ref<string | null>(getidUsuario.value);

const verDetalleInscripcion = (idInscripcion: number) => {
  currentInscripcionId.value = idInscripcion;
  currentTorneoId.value =
    listaTorneos.value.find(
      (i) => i.idInscripcion == currentInscripcionId.value
    )?.idTorneo ?? null;
  currentIdOrganizador.value =
    listaTorneos.value.find(
      (i) => i.idInscripcion == currentInscripcionId.value
    )?.idOrganizador ?? null;

  showModalInscripcion.value = true;
};

const verDetalleTorneo = (idTorneo: number) => {
  router.push({ name: "detalle-torneo", params: { idTorneo } });
};
const VerResultadoTorneo = (idTorneo: number) => {
  router.push({ name: "detalle-torneo-live", params: { idTorneo } });
};
const VerResultadoTorneoMas = (idTorneo: number) => {
  router.push({ name: "detalle-torneo-live-mas", params: { idTorneo } });
};

const eliminarInscripcion = async (idInscripcion: number) => {
  isRegistering.value = true;
  try {
    const response = await cancelarInscripcion(idInscripcion);

    if (response.request?.status === 200) {
      showSuccessModal.value = true;
      const responseInscriptionesUser = await getInscripcionesIndividualByUser(
        listaTorneos.value[0].idUsuario.toString()
      );
      listaTorneos.value = responseInscriptionesUser.data;
    } else {
      showErrorModal.value = true;
    }
  } catch {
    isRegistering.value = false;
    showErrorModal.value = true;
  } finally {
    isRegistering.value = false;
  }
};

onMounted(async () => {
  listaTorneos.value = props.listaTorneos;
  if (idUsuarioLogger.value != null) {
    if (props.idUsuario === parseInt(idUsuarioLogger.value)) {
      hasAcciones.value = true;
    }
  }
});

// Cierra el modal
const closeModal = () => {
  showModalInscripcion.value = false;
  showModalInscripcionEquipo.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!hasAcciones.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_v_container, { loading: _ctx.isLoading }, {
            default: _withCtx(() => [
              _createVNode(_component_v_list, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listaTorneos.value, (torneo) => {
                    return (_openBlock(), _createBlock(_component_v_list_item, {
                      key: torneo.idInscripcion,
                      onClick: ($event: any) => (verDetalleTorneo(torneo.idTorneo)),
                      class: "clickable-list-item"
                    }, {
                      prepend: _withCtx(() => [
                        _hoisted_2
                      ]),
                      append: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          icon: "",
                          onClick: _withModifiers(($event: any) => (verDetalleTorneo(torneo.idTorneo)), ["stop"])
                        }, {
                          default: _withCtx(() => [
                            _hoisted_3
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_title, { class: "text-wrap text-left pl-2" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(torneo.torneo.nombreTorneo), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["loading"])
        ]))
      : _createCommentVNode("", true),
    (hasAcciones.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_v_container, {
            loading: _ctx.isLoading,
            class: "mb-0 pb-0"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_list, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listaTorneos.value, (torneo) => {
                    return (_openBlock(), _createBlock(_component_v_list_item, {
                      key: torneo.idInscripcion,
                      onClick: ($event: any) => (verDetalleTorneo(torneo.idTorneo)),
                      class: "clickable-list-item"
                    }, {
                      prepend: _withCtx(() => [
                        _hoisted_5
                      ]),
                      append: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          icon: "",
                          onClick: _withModifiers(($event: any) => (
                torneo.torneo.tipoTorneo == 'Individual' &&
                torneo.torneo.listasPorJugador > 1
                  ? VerResultadoTorneoMas(torneo.idTorneo)
                  : VerResultadoTorneo(torneo.idTorneo)
              ), ["stop"])
                        }, {
                          default: _withCtx(() => [
                            _hoisted_6
                          ]),
                          _: 2
                        }, 1032, ["onClick"]),
                        _createVNode(_component_v_btn, {
                          icon: "",
                          onClick: _withModifiers(($event: any) => (verDetalleInscripcion(torneo.idInscripcion)), ["stop"])
                        }, {
                          default: _withCtx(() => [
                            _hoisted_7
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_title, { class: "text-wrap text-left pl-2" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(torneo.torneo.nombreTorneo), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["loading"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(ModalSuccess, {
      isVisible: showSuccessModal.value,
      message: "Eliminado con exito.",
      "onUpdate:isVisible": _cache[0] || (_cache[0] = ($event: any) => (showSuccessModal.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(ModalError, {
      isVisible: showErrorModal.value,
      message: "No se ha podido eliminar. Contacta con el administrador.",
      "onUpdate:isVisible": _cache[1] || (_cache[1] = ($event: any) => (showErrorModal.value = $event))
    }, null, 8, ["isVisible"]),
    (showModalInscripcion.value)
      ? (_openBlock(), _createBlock(ModalInscripcion, {
          key: 2,
          idInscripcion: currentInscripcionId.value!,
          idUsuario: parseInt(idUsuarioLogger.value!),
          idTorneo: currentTorneoId.value!,
          idOrganizador: currentIdOrganizador.value!,
          onEliminarInscripcion: eliminarInscripcion,
          onClose: closeModal
        }, null, 8, ["idInscripcion", "idUsuario", "idTorneo", "idOrganizador"]))
      : _createCommentVNode("", true),
    _createVNode(_component_v_dialog, {
      modelValue: isRegistering.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((isRegistering).value = $event)),
      persistent: "",
      width: "300"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_text, {
              class: "d-flex justify-center align-center",
              style: {"height":"150px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_progress_circular, {
                  indeterminate: "",
                  color: "blue-lighten-3",
                  size: 57
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})